<script lang="ts">
  // Marks where the unread messages/comments start in an open thread -- see DateDivider.svelte
  // for the sibling date-grouping divider this is styled to sit alongside. The caller computes
  // {count} once (before marking the thread read) and keeps it fixed for the life of the pane, so
  // this doesn't move as more gets marked read during the same viewing session.
  export let count: number;
</script>

<div class="my-3 flex items-center gap-2">
  <div class="h-px flex-1 bg-destructive/40"></div>
  <span class="shrink-0 text-[11px] font-semibold uppercase tracking-wide text-destructive">{count} unread</span>
  <div class="h-px flex-1 bg-destructive/40"></div>
</div>
